import ModelPage from '@/pages/MainPage.vue'
import FleetPage from '@/pages/FleetPage.vue'
import Stock from '../pages/Stock'
import Consultation from '../pages/Consultation'
import LeadValidation from '../pages/LeadValidation'

export default [
  {
    path: '/lead-validation',
    name: 'lead-validation',
    component: LeadValidation
  },
  {
    path: '/service',
    name: 'service',
    component: ModelPage
  },
  {
    path: '/stock',
    name: 'stock',
    component: Stock
  },
  {
    path: '/online',
    name: 'online',
    component: Consultation
  },
  {
    path: '/fleet',
    name: 'fleet',
    meta: { requiresAuth: true },
    component: FleetPage
  },

  {
    path: '/thank-you',
    name: 'thank-you',
    component: () => import(/* webpackChunkName: "thank-you" */ '@/pages/ThankYouPage.vue')
  },

  {
    path: '/thank-you-fleet',
    name: 'thank-you-fleet',
    component: () => import(/* webpackChunkName: "thank-you" */ '@/pages/ThankYouFleetPage.vue')
  },

  {
    path: '/policy',
    name: 'policy',
    component: () => import(/* webpackChunkName: "policy" */ '@/pages/PolicyPage.vue')
  },

  {
    path: '/marketing',
    name: 'marketing',
    component: () => import(/* webpackChunkName: "policy" */ '@/pages/MarketingPage.vue')
  },

  {
    path: '/policy-fleet',
    name: 'policy-fleet',
    component: () => import(/* webpackChunkName: "policy" */ '@/pages/PolicyFleetPage.vue')
  },

  {
    path: '/marketing-fleet',
    name: 'marketing-fleet',
    component: () => import(/* webpackChunkName: "policy" */ '@/pages/MarketingFleetPage.vue')
  },

  {
    path: '/not-found',
    name: 'not-found',
    component: () => import(/* webpackChunkName: "not-found" */ '@/pages/NotFoundPage.vue')
  },
  {
    path: '*',
    redirect: '/not-found'
  }
]
